import React from "react";

const DetailSection: React.FC<{
  title: string;
  id?: string;
  children: React.ReactNode;
}> = ({ title, id, children }) => (
  <div
    id={id}
    className="flex rounded overflow-hidden border border-gray-200 bg-white"
  >
    <div className="relative w-7 min-w-7 bg-gray-100 border-r border-gray-200 shrink-0">
      <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-90 whitespace-nowrap text-[10px] font-semibold text-gray-500 uppercase tracking-wider">
        {title}
      </span>
    </div>
    <div className="flex-1 min-w-0 p-2">{children}</div>
  </div>
);

export default DetailSection;
